export default "__VITE_ASSET__DCoWiqrc__"